import React, { useState } from 'react';
import ChatBot from './ChatBot';
import Results from './Results';
import { Box, CssBaseline, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { brandGradient } from '../../shared-theme/themePrimitives';

const PANEL_HEIGHT = 'calc(100vh - var(--template-frame-height, 0px) - 72px)';

const ChatBotPage = () => {
    const [results, setResults] = useState([]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // e.g. <600px

    return (
        <>
            <CssBaseline />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    height: PANEL_HEIGHT,
                    overflow: 'hidden',
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: { xs: 0, sm: 3 },
                    mx: { xs: 0, sm: 2 },
                }}
            >
                {/* Chatbot Panel */}
                <Box
                    sx={{
                        width: isMobile ? '100%' : 380,
                        minWidth: isMobile ? '100%' : 300,
                        bgcolor: 'background.paper',
                        borderRight: isMobile ? 'none' : '1px solid',
                        borderBottom: isMobile ? '1px solid' : 'none',
                        borderColor: 'divider',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        maxHeight: isMobile ? '45vh' : '100%',
                        flexShrink: 0,
                    }}
                >
                    <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 700,
                                background: brandGradient,
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                display: 'inline-block',
                            }}
                        >
                            AI Bot
                        </Typography>
                        <Typography variant="caption" color="text.secondary" display="block">
                            Tell us what you're looking for
                        </Typography>
                    </Box>
                    <Box sx={{ p: 2, overflowY: 'auto', flexGrow: 1 }}>
                        <ChatBot setResults={setResults} />
                    </Box>
                </Box>

                {/* Results Panel */}
                <Box
                    sx={{
                        flexGrow: 1,
                        p: { xs: 2, sm: 3 },
                        bgcolor: 'background.default',
                        overflowY: 'auto',
                        minWidth: 0,
                        maxHeight: '100%',
                    }}
                >
                    <Results results={results} />
                </Box>
            </Box>
        </>
    );
};

export default ChatBotPage;
